import { render, staticRenderFns } from "./cardCases.vue?vue&type=template&id=661f53c5"
import script from "./cardCases.vue?vue&type=script&lang=js"
export * from "./cardCases.vue?vue&type=script&lang=js"
import style0 from "./cardCases.vue?vue&type=style&index=0&id=661f53c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports